import React from 'react';
import get from 'lodash/get';
import * as PropTypes from 'prop-types';

import SimpleAvatar from '../../../../common/SimpleAvatar';
import Loader from '../../../../common/Loader';
import Popup from '../../../../common/Popup';
import Icon from '../../../../Icon';
import {
  ACTIVITIES_SUBCHANNEL,
  ALL_MEMBERS_SUBCHANNEL,
  FAMILY_CIRCLE_SUBCHANNEL,
  NOTIFICATIONS_SUBCHANNEL,
} from '../../../constants';
import { getReadOnlyChannelData } from '../../../../../utils/messaging/readOnlyChat';
import { getSafeChannelName, getSafeUserId } from '../../utils';
import { enhance } from './enhance';
import styles from './index.styl';

function ShareToChatModal({
  intl: { formatMessage },
  openedShareToChatModal,
  allPatientChannels,
  allSocialChannels,
  targetUserId,
  shareToChat,
  documentUid,
  mainUserId,
  pending,
  close,
}) {
  const { safeUserId, isMainUser } = getSafeUserId(targetUserId, mainUserId);

  const handleCloseModal = () => {
    close();
  };

  const patientChannels = allPatientChannels.filter(
    ({ contextUser }) => contextUser.id === safeUserId,
  );

  const patientSubChannels = patientChannels[0]
    ? patientChannels[0].subchannels
    : [];

  const patientAllowedSubChannels = patientSubChannels.reduce((acc, item) => {
    const { channelName } = item;
    const isSystemChannel = [
      NOTIFICATIONS_SUBCHANNEL,
      ACTIVITIES_SUBCHANNEL,
    ].includes(channelName);

    const { blocked, isReadOnly } = getReadOnlyChannelData({
      contextChannel: item,
    });
    const isAllowedChannel = !isReadOnly && !blocked && !isSystemChannel;

    return isAllowedChannel ? [...acc, item] : acc;
  }, []);

  const socialSubChannels =
    allSocialChannels.length > 0
      ? allSocialChannels.map(
          ({ contextChannel: { channelName, channelId, avatar } }) => ({
            channelName,
            channelId,
            avatar,
          }),
        )
      : [];

  const allAvailableChats = [
    ...patientAllowedSubChannels,
    ...(isMainUser && socialSubChannels),
  ];

  const handleShareToChat = (id, channelName) => {
    shareToChat({
      userId: safeUserId,
      documentUid,
      roomId: id,
      channelName,
    });
  };

  return (
    <Popup
      title={formatMessage({ id: 'patient.portal.healthRecord.shareToChat' })}
      onClose={handleCloseModal}
      opened={openedShareToChatModal}
      mobileFullScreen={false}
      overflowVisible
      withoutAdaptive
      strictClose
    >
      <div className={styles.root}>
        {pending && <Loader />}
        {!pending && (
          <div className={styles.content}>
            {allAvailableChats.map(({ channelId, channelName, avatar }) => {
              const isDefaultPatientChat = [
                ALL_MEMBERS_SUBCHANNEL,
                FAMILY_CIRCLE_SUBCHANNEL,
              ].includes(channelName);
              const safeChatName = isDefaultPatientChat
                ? getSafeChannelName(channelName, formatMessage)
                : channelName;
              return (
                <div
                  className={styles.chatRoot}
                  key={channelId}
                  onClick={() => handleShareToChat(channelId, safeChatName)}
                >
                  {isDefaultPatientChat ? (
                    <Icon size={32} name="icon-group" />
                  ) : (
                    <SimpleAvatar
                      className={styles.avatar}
                      text={channelName}
                      src={get(avatar, 'thumbMin')}
                      size={32}
                    />
                  )}
                  <div className={styles.title}>{safeChatName}</div>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </Popup>
  );
}

ShareToChatModal.propTypes = {
  intl: PropTypes.object,
  close: PropTypes.func,
  openedShareToChatModal: PropTypes.bool,
  mainUserId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  targetUserId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  pending: PropTypes.bool,
  allPatientChannels: PropTypes.array,
  shareToChat: PropTypes.func,
  documentUid: PropTypes.string,
  allSocialChannels: PropTypes.array,
};

export default enhance(ShareToChatModal);



// WEBPACK FOOTER //
// ./src/components/PatientHealthboard/PatientPortal/DataList/ShareToChatModal/index.jsx